<template>
    <div>
        <title>{{ $t("account.title") }}</title>
        <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
        />
        <div class="cont">
            <h1>{{ $t("account.mainucet_text_0") }}</h1>
            <h3>{{ $t("account.mainucet_text_1") }}</h3>
            <div class="first">
                <h3>{{ $t("account.mainucet_text_2") }}</h3>
                <osobne-udaje
                    :data_user="user"
                    v-on:data="getData($event, 1)"
                />
            </div>
            <div class="ulozit" @click="save_OU">
                <span v-show="!saved_OU">{{
                    $t("account.mainucet_text_5")
                }}</span>
                <div v-show="saved_OU" class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="first mt-4">
                <h3>{{ $t("account.mainucet_text_3") }}</h3>
                <h4>{{ $t("account.mainucet_text_4") }}</h4>
                <ip-address :ipaddresses="ipaddresses" :user="user" />
            </div>

            <div class="first mt-5">
                <h3>{{ $t("account.mainucet_text_6") }}</h3>
                <zmena-hesla />
            </div>
            <div v-if="is_admin" class="first mt-5">
                <h3>Template typ ponuky</h3>
                <div data-app>
                    <v-select
                        v-model="template_type"
                        :items="templates"
                        item-text="label"
                        item-value="id"
                        label="Template"
                        filled
                        hide-details
                    />
                </div>
                <div
                    class="ulozit mt-3"
                    style="width: 100%; margin: 12px 0 0 0"
                    @click="saveTemplateType"
                >
                    <span v-show="!saving_template">Uložiť template</span>
                    <div
                        v-show="saving_template"
                        class="lds-ellipsis"
                        style="height: 40px"
                    >
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>

            <div class="first mt-3">
                <h3>{{ $t("account.mainucet_text_7") }}</h3>
                <h4>
                    {{ $t("account.mainucet_text_8") }} <br /><br />
                    {{ $t("account.mainucet_text_9") }}
                    <a href="mailto:help@doffero.com ">help@doffero.com</a>
                    {{ $t("account.mainucet_text_10") }}
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
import OsobneUdaje from "./components/OsobneUdaje.vue";
import IpAddress from "./components/IpAddress.vue";
import ZmenaHesla from "./components/ZmenaHesla.vue";
export default {
    props: ["data_user", "data_ipaddresses", "is_admin"],
    components: { OsobneUdaje, IpAddress, ZmenaHesla },
    data() {
        return {
            user: null,
            saved_OU: false,
            ipaddresses: [],
            resetNewPasswords: false,
            actualPassword: "",
            newPassword: "",
            template_type: null,
            saving_template: false,
            templates: [
                { id: 0, label: "Default (0)" },
                { id: 1, label: "Delnet (1)" },
                { id: 2, label: "VeselyCaj (2)" },
                { id: 3, label: "RailJob (3)" },
                { id: 4, label: "Kriejt (4)" },
                { id: 5, label: "Pivovar (5)" },
                { id: 6, label: "Vol. 2 (6)" },
                { id: 7, label: "DEMISPORT (7)" },
                { id: 9, label: "HomeSystem (9)" },
                { id: 10, label: "Auvid (10)" },
                { id: 11, label: "PMLService (11)" },
                { id: 12, label: "Zabes (12)" },
            ],
        };
    },
    created() {
        this.user = this.data_user;
        this.ipaddresses = this.data_ipaddresses;
        this.template_type = this.data_user ? this.data_user.template_type : 0;
    },
    methods: {
        save_OU() {
            this.saved_OU = true;
            axios
                .patch(`/api/settings/ucet`, {
                    user: this.user,
                })
                .then((response) => {
                    setTimeout(() => {
                        this.saved_OU = false;
                        this.$toast.success("Informacie boli uložené.", {
                            timeout: 2038,
                        });
                    }, 500);
                });
        },
        saveTemplateType() {
            this.saving_template = true;
            axios
                .patch(`/api/settings/template-type`, {
                    template_type: this.template_type,
                })
                .then(() => {
                    setTimeout(() => {
                        this.saving_template = false;
                        this.$toast.success("Template bol zmenený.", {
                            timeout: 2038,
                        });
                    }, 500);
                });
        },
        getData(value, id) {
            if (id == 1) {
                this.user.meno = value.meno;
                this.user.priezvisko = value.priezvisko;
            }
        },
    },
    mounted() {
        $(".tooltip_hover").hover(
            function () {
                $(this).parent().find(".my_tooltip").css("opacity", "1");
            },
            function () {
                $(this).parent().find(".my_tooltip").css("opacity", "0");
            }
        );
    },
};
</script>

<style lang="scss" scoped>
.cont {
    width: 1188px;
    margin: 0 auto;
    padding: 35px 0;
    @media only screen and (max-width: 1500px) {
        width: 95%;
    }
    h1 {
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
    }
    h3 {
        width: 700px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 10px auto 27px auto;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: #9598a7;
    }
    .first {
        width: 480px;
        padding: 24px;
        background: #ffffff;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        margin: 0 auto;
        h3 {
            width: auto;
            margin: 0 0 19px 0;
            font-family: "Roboto";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 21px;
            color: #212541;
            text-align: left;
        }
        h4 {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 21px;
            color: #9598a7;
            margin-bottom: 18px;
            a {
                font-family: "Roboto";
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 21px;
                color: #9598a7;
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .form-group {
            display: flex;
            align-items: center;
            margin-bottom: 0px;
        }
        label {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
        input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            margin: 0px 10px 0 0px;
            background: #c7d4eb;
            border-radius: 25px;
        }
        .toggle {
            height: 22px;
            width: 40px;
            display: inline-block;
            position: relative;
            margin: 0;
            border: none;
            background: #ffffff;
            border-radius: 3px;
            transition: all 0.2s ease;
            &:focus {
                outline: 0;
            }
            &:after {
                content: "";
                position: absolute;
                top: 4px;
                left: 3px;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background: white;
                box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
            }
            &:checked {
                border-color: #2ed8b6;
                background: #2ed8b6;
            }
            &:checked:after {
                transform: translatex(20px);
            }
        }
        .info {
            position: relative;
            height: 20px;
            margin-left: 10px;
            .info_icon {
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;
                img {
                    width: 80%;
                    height: 80%;
                }
            }
            .my_tooltip {
                bottom: 22px;
                right: -7px;
            }
        }
        .agree_tooltip {
            position: relative;
        }
        .my_tooltip {
            font-family: "Roboto";
            font-style: normal;
            font-weight: 700;
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #f3385a;
            box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
            border-radius: 6px;
            font-weight: 800;
            font-size: 14px;
            line-height: 18px;
            color: #fff;
            padding: 10px;
            position: absolute;
            top: unset;
            right: 15px;
            z-index: 10000;
            transition: opacity 0.5s ease-in-out;
            &::after {
                content: "";
                width: 15px;
                height: 15px;
                background: #f3385a;
                position: absolute;
                right: 10px;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
    }
    .ulozit {
        width: 480px;
        height: 55px;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
        margin: 15px auto 0 auto;
        background: #2ed8b6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;
        transition: 0.5s all;
        &:hover {
            background: #23caa9;
        }
    }
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}
</style>
